/*
全局API配置
*/
import VConsole from 'vconsole';

const base = {
    baseURL: 'https://www.inkmaster.cn/api/inkmaster',   // 服务器测试地址
    timeout: 10000,                             // 请求超时时间
    draft_ws: 'wss://www.inkmaster.cn/api/inkmaster/draft/interactive/'
}

const host = window.location.hostname;

if (host === 'local.inkmaster.cn') {  // 连接本地测试环境
    base.baseURL = 'http://localhost:9876/inkmaster'
    base.draft_ws = 'ws://localhost:9876/inkmaster/draft/interactive/'
    const vConsole = new VConsole();
}

if (host === 'localhost' || host.startsWith('172') || host.startsWith('192')) {  // 连接本地测试环境，测试
    base.baseURL = 'http://localhost:9876/inkmaster'
    base.draft_ws = 'ws://localhost:9876/inkmaster/draft/interactive/'
    const vConsole = new VConsole();
}

export default base